import { Injectable } from "@angular/core";
import { CoreService } from "../../base/core";
import { ServiceRoute } from "../../base/service-route";
import { CommonHttpOption } from "../../base/common-http-option";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class SubsidiaryCompanyAgentService {
  constructor(private coreService: CoreService) {}

  // get customer agent
  getCustomerAgentList(params: any, pageIndex: number = 1, pageSize: number = 10): Observable<any> {
    return this.coreService.get(
      ServiceRoute.subsidiary.agent.getCustomerAgentList,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(pageIndex, pageSize)  
      .append('Id', params && params.Id ? params.Id : '')
      .append('AgentName', params && params.AgentName ? params.AgentName : '')
      .append('IsMain', params && params.IsMain ? params.IsMain : '')
      .append('CustomerId', params && params.CustomerId ? params.CustomerId : '')
  );
  }
    // add customer Agent 
    customerAgentAdd(command: any): Observable<any> {
      return this.coreService.post(
        ServiceRoute.subsidiary.agent.customerAgentAdd,
        command,
        new CommonHttpOption().headers
      );
    }
    // edit customer agent
    customerAgentEdit(command: any): Observable<any> {
    return this.coreService.put(
      ServiceRoute.subsidiary.agent.customerAgentEdit,
      command,
      new CommonHttpOption().headers
    );
  }
}
